// frontend/dashboard/src/router/modules/setupRoutes.js
// Responsible for: setup wizard routes — create company, create site, add robot
// English: Protected routes for first-time setup. All require authentication.
// Thai: routes สำหรับ setup ครั้งแรก ต้องการ authentication ทั้งหมด

import { debugLog } from '../../utils/debugGate.js';

const ROUTE_DEBUG_NAMESPACE = '[router/setupRoutes]';

const PAGE_REGISTRY = {
  CompanySetupPage: () => import('../../pages/CompanySetupPage.vue'),
  SiteSetupPage:    () => import('../../pages/SiteSetupPage.vue'),
  AddRobotPage:     () => import('../../pages/AddRobotPage.vue'),
};

function buildLazyPage(registryKey, debugLabel) {
  return async () => {
    const loader = PAGE_REGISTRY[registryKey];
    if (!loader) throw new Error(`${ROUTE_DEBUG_NAMESPACE} No registry entry for: ${registryKey}`);

    try {
      const module = await loader();
      // [Debug output disabled — freeze/performance isolation | ปิด debug output ชั่วคราวเพื่อแยกปัญหา freeze/performance]
      // debugLog(`${ROUTE_DEBUG_NAMESPACE} [LAZY_IMPORT_SUCCESS]`, { registryKey, debugLabel });
      return module;
    } catch (error) {
      console.error(`${ROUTE_DEBUG_NAMESPACE} [LAZY_IMPORT_ERROR]`, {
        registryKey,
        error: error instanceof Error ? error.message : String(error),
      });
      throw error;
    }
  };
}

const setupRoutes = [
  {
    path: '/setup/company',
    name: 'CompanySetup',
    component: buildLazyPage('CompanySetupPage', 'CompanySetupPage'),
    meta: {
      section:      'setup',
      requiresAuth: true,
      layout:       'blank',
      title:        'Create Company',
    },
  },
  {
    path: '/setup/site',
    name: 'SiteSetup',
    component: buildLazyPage('SiteSetupPage', 'SiteSetupPage'),
    meta: {
      section:      'setup',
      requiresAuth: true,
      layout:       'blank',
      title:        'Create Site',
    },
  },
  {
    path: '/setup/robot',
    name: 'AddRobot',
    component: buildLazyPage('AddRobotPage', 'AddRobotPage'),
    meta: {
      section:      'setup',
      requiresAuth: true,
      layout:       'blank',
      title:        'Add Robot',
    },
  },
];

// [Debug output disabled — freeze/performance isolation | ปิด debug output ชั่วคราวเพื่อแยกปัญหา freeze/performance]
// debugLog(`${ROUTE_DEBUG_NAMESPACE} [ROUTES_REGISTERED]`, {
//   routeCount: setupRoutes.length,
//   routeNames: setupRoutes.map((r) => r.name),
// });

export default setupRoutes;
